
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learning/showcase/veranda",
      function () {
        return require("private-next-pages/learning/showcase/veranda/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learning/showcase/veranda"])
      });
    }
  